import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';

import { PublicacionesPlataformaService } from '../../services/publicaciones-plataforma.service';
import {
  EstadoPlataformaDTO,
  MantenimientoPlataformaPublico,
} from '../../services/workspace/DTO/publicacion-plataforma.dto';

@Component({
  selector: 'app-aviso-plataforma',
  templateUrl: './aviso-plataforma.component.html',
  styleUrls: ['./aviso-plataforma.component.scss'],
})
export class AvisoPlataformaComponent implements OnInit, OnDestroy {
  @Input() modo: 'login' | 'sistema' = 'sistema';

  mantenimiento: MantenimientoPlataformaPublico | null = null;
  mantenimientoEnCurso = false;
  private subscription: Subscription;

  constructor(private publicacionesService: PublicacionesPlataformaService) {}

  /**
   * Observa la agenda singleton ya iniciada por el componente raiz, el
   * bloqueo vigente y los avisos que el usuario cerro (en el servidor o en
   * esta sesion) para elegir el aviso visible.
   */
  ngOnInit(): void {
    this.subscription = combineLatest([
      this.publicacionesService.estado$,
      this.publicacionesService.activo$,
      this.publicacionesService.avisosCerrados$,
    ]).subscribe(([estado, activo, cerrados]) => this.actualizarAviso(estado, activo, cerrados));
  }

  /**
   * Libera la observacion cuando cambia el layout entre login y sistema sin
   * detener el sondeo central compartido por toda la aplicacion.
   */
  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  /**
   * Cierra el aviso visible; el servicio lo oculta al instante y, con sesion,
   * guarda el cierre en el servidor para la revision vigente.
   */
  cerrar(): void {
    if (!this.mantenimiento) return;
    this.publicacionesService.cerrarAviso(this.mantenimiento);
  }

  /**
   * Elige la primera ventana de hoy aun no cerrada, en curso o futura segun la
   * hora del servidor. El bloqueo tapa el sistema, salvo en el login, donde
   * el aviso explica por que no se puede trabajar.
   */
  private actualizarAviso(
    estado: EstadoPlataformaDTO | null,
    activo: MantenimientoPlataformaPublico | null,
    cerrados: Set<string>
  ): void {
    this.mantenimiento = null;
    this.mantenimientoEnCurso = false;
    if (!estado || (activo && this.modo !== 'login')) return;
    const ventanas = [estado.mantenimientoActivo, ...(estado.mantenimientosDeHoy || [])]
      .filter(item => !!item);
    const ahora = this.publicacionesService.obtenerAhoraServidor();
    this.mantenimiento = ventanas.find(item =>
      new Date(item.fechaFin).getTime() > ahora &&
      !cerrados.has(this.publicacionesService.claveAviso(item.uuid, item.revisionAviso))
    ) || null;
    this.mantenimientoEnCurso = !!this.mantenimiento &&
      new Date(this.mantenimiento.fechaInicio).getTime() <= ahora;
  }

  /**
   * Renderiza horas ecuatorianas de forma consistente tanto antes como despues
   * de iniciar sesion, independientemente de la zona del navegador.
   */
  formatearHora(fecha: string): string {
    return new Intl.DateTimeFormat('es-EC', {
      timeZone: 'America/Guayaquil',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(new Date(fecha));
  }
}
